module.exports = __webpack_public_path__ + "img/gfyh.1403a53f.png";